module.exports = __webpack_public_path__ + "static/media/mindful_icon_original.a1804d84.png";